/* eslint-disable func-names */

// Removes duplicates from an array of objects
// eslint-disable-next-line no-extend-native
export default Array.prototype.uniqueObjects = function () {
  return this.filter(
    (value, index, array) => index === array.findIndex((t) => t?._id === value?._id)
  );
};
